import { render } from "./ListNotesPage.vue?vue&type=template&id=0ff576a0&ts=true"
import script from "./ListNotesPage.vue?vue&type=script&lang=ts"
export * from "./ListNotesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__